import { rolesQuery } from "@common/api/roles"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { NewRolePage } from "@/routes/_layout/settings/_panel/workspace/roles/-components/new-role-page"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/roles/duplicate/$roleId",
)({
  staticData: { breadcrumb: "Duplicate role" },
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(rolesQuery()),
  component: DuplicateRolePage,
})

function DuplicateRolePage(): React.ReactElement {
  const { roleId } = Route.useParams()
  const { data } = useSuspenseQuery(rolesQuery())
  const source = data.data.find((role) => role.id === roleId)

  return (
    <NewRolePage source={source?.matches_capabilities ? source : undefined} />
  )
}
